var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 19.5446L14.1188 12.5696C15.0563 11.2618 15.6141 9.65401 15.6141 7.91961C15.6141 3.55557 12.1125 0.00244604 7.80937 0.00244604C3.50156 -0.00224146 0 3.55088 0 7.91495C0 12.279 3.50156 15.8321 7.80472 15.8321C9.6703 15.8321 11.3813 15.1665 12.7266 14.0555L19.5703 20.9978L21 19.5446ZM7.80472 14.004C4.49531 14.004 1.8 11.2712 1.8 7.91495C1.8 4.55869 4.49531 1.82588 7.80472 1.82588C11.1141 1.82588 13.8094 4.55869 13.8094 7.91495C13.8094 11.2712 11.1188 14.004 7.80472 14.004Z","fill":"#2F2357"}));
}

Search.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = Search;

Search.default = Search;
